import Page from 'flarum/common/components/Page';

export default class FAQPage extends Page {
    oninit(){
        this.content = (
            <>
                {m.trust(app.forum.attribute('info-pages.faq-content'))}
            </>
        )
    }


    view() {
        return this.content;
    }
}
